// extracted by mini-css-extract-plugin
export default {"wrapper":"IrBBikMmK+yLBxPMzS8Fsw==","title":"gh8qUhHRNvERdn6FO0V9Mg==","actions":"_6rDeO0YzLx+v85vwNtwzvg=="};